module.exports = __webpack_public_path__ + "static/media/cambridge.dc01596d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cambridge.png
// module id = 1223
// module chunks = 0